import { useEffect } from 'react';
import { useTraccarMessage } from './useTraccarSocket';
import { useCommandsStore } from '@/stores/commands';

/**
 * Escuta eventos `commandResult` no WebSocket e correlaciona com o último
 * comando pendente da mesma máquina (heurística temporal, porque o Traccar
 * não devolve o id do comando no evento).
 *
 * Também roda prune periódico pra marcar como 'timeout' comandos que
 * passaram da janela sem confirmação.
 */
export function useCommandResultListener() {
  const confirm = useCommandsStore((s) => s.confirm);
  const pruneTimeouts = useCommandsStore((s) => s.pruneTimeouts);

  useTraccarMessage((msg) => {
    if (!msg.events?.length) return;
    for (const event of msg.events) {
      if (event.type !== 'commandResult') continue;
      if (event.deviceId == null) continue;
      const result =
        typeof event.attributes?.result === 'string'
          ? (event.attributes.result as string)
          : undefined;
      confirm(event.deviceId, event.id, result);
    }
  });

  useEffect(() => {
    const id = setInterval(() => pruneTimeouts(), 30_000);
    return () => clearInterval(id);
  }, [pruneTimeouts]);
}
